module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<img class="product_search_subcategory_photo" src="' +
__e( src ) +
'" alt="' +
__e( alt ) +
'" width="32" height="32"\n     onerror="this.style.opacity=\'0\'">\n<p class="product_search_subcategory_name">' +
((__t = ( name )) == null ? '' : __t) +
'</p>\n';

}
return __p
}